import { render, staticRenderFns } from "./InvoiceView.vue?vue&type=template&id=5ffd1ffa&scoped=true"
import script from "./InvoiceView.vue?vue&type=script&lang=js"
export * from "./InvoiceView.vue?vue&type=script&lang=js"
import style0 from "./InvoiceView.vue?vue&type=style&index=0&id=5ffd1ffa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffd1ffa",
  null
  
)

export default component.exports